module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAMAAACDzGUcAAAAAXNSR0IB2cksfwAAAD9QTFRFAAAAQq/5Qq/6Qq/6RK/7Q6/5Qa/6QK//Qq/7Q6/7Qq/6Qq/6QK/3Qq/6Qq/6QK/6Qq/6Qa/6Qq/6Qq/6Q6/6pjVbBAAAABV0Uk5TAIDA4EBQoBB/sHDQIJBgMN+/7/DPKrxZ/gAAAHZJREFUeJxtj+0agBAMhWlYE6nW/V9riXyU82M8r+04E3ICJQbSZkQR5o8wYjKyU7K0sh9enuqWDjrKj66l1qbTry2l3BOopfC7dPGNrrTa6W0vOrA08Hfh9G8YUc/wOvBZ0gMiqChvmhB80zdXpStDDkQnOHEByB0EdrLlMAAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-cart.png
// module id = 749
// module chunks = 1